import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useParams } from "react-router";
import withRedirect from "../../helpers/hoc/withRedirect";
import {
  fetchReserveFundDetails,
  findOneReserve,
  toggleReserveFundPaymentStatus,
} from "../../helpers/api/finance";
import EditReserveFundAmountModal from "./EditReserveFundAmountModal";
import PageHeader from "../common/PageHeader";
import { useSelector } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  Col,
  Alert,
  Row,
  Table,
  Badge,
  Label,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isIterableArray } from "../../helpers/utils";
import { PreloadState } from "../UI/preloading/PreloadState";
import SupportLink from "../root/support/components/SupportLink";
import NumberFormat from "react-number-format";
import Datetime from "react-datetime";
import moment from "moment";
import {
  findCondominiumMovementsReseveFunds,
} from "../../helpers/api/condominium";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import FalconCardHeader from "../common/FalconCardHeader";
import {
  faFilter,
  faSearch,
  faToggleOn,
  faToggleOff,
} from "@fortawesome/free-solid-svg-icons";
import ButtonIcon from "../common/ButtonIcon";
import FullPagination from "../common/pagination/FullPagination";
import html2canvas from "html2canvas";
// eslint-disable-next-line import/no-named-as-default
import jsPDF from "jspdf";
import { useReactToPrint } from "react-to-print";
import Logo from "../navbar/Logo";
import { CurrencyContext } from "../../context/Context";
import Swal from "sweetalert2";
import { Toast } from "../UI/toast/Toast";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";

const ReserveFundDetails = ({ setRedirect, setRedirectUrl }) => {
  const { reserveFundId } = useParams();
  const { condominium, address, phone } = useSelector(
    (state) => state.condominium
  );
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const [isLoading, setIsLoading] = useState(true);
  const [reserveFund, setReserveFund] = useState([]);
  const [error, setError] = useState(null);
  const [amount, setAmount] = useState(0);
  const [editingPayment, setEditingPayment] = useState(null);
  const { role } = useSelector((state) => state.auth.user);
  const [formDate, setformDate] = useState({
    since: null,
    to: null,
  });
  const reportRef = useRef();
  const [params, setParams] = useState({
    condominiumId: role === "manager" ? selectedCondominium : null,
    start_date: null,
    end_date: null,
    reserveFund: reserveFundId,
  });


  const {
    data,
    isLoading: movementsFund,
    handler: { goToPage, nextPage, perPage, previousPage },
    meta,
  } = useSWRFetchPagination(findCondominiumMovementsReseveFunds, params);

  const filteredData = data.map((item) => {
    try {
      const parsedDescription = JSON.parse(item.description);
      return { ...item, description: parsedDescription };
    } catch (error) {
      return item;
    }
  });

  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  const resolveConvertedAmount = (movement) => {
    if (movement?.amount_converted !== null && movement?.amount_converted !== undefined) {
      const storedAmount = Number(movement.amount_converted);
      if (Number.isFinite(storedAmount)) {
        return storedAmount;
      }
    }

    const amount = Number(movement?.amount);
    const exchangeRate = Number(curr?.value || 0);
    return Number.isFinite(amount) && exchangeRate > 0
      ? amount * exchangeRate
      : null;
  };
  const getDate = (date) => {
    const d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  const [showReserve, setShowReserve] = useState([]);
  const fetchApiShow = useCallback(async () => {
    try {
      const response = await findOneReserve(reserveFundId);
      setShowReserve(response.data ? response.data : []);
    } catch (error) {
      setShowReserve([]);
    }
  }, []);
  useEffect(() => {
    fetchApiShow();
  }, [fetchApiShow]);

  const handleDownload = async () => {
    const canvas = await html2canvas(reportRef.current, {
      windowWidth: reportRef.current.scrollWidth,
      windowHeight: reportRef.current.scrollHeight,
    });
    const imgData = canvas.toDataURL("image/png");

    // eslint-disable-next-line new-cap
    const pdf = new jsPDF("p", "mm", "a4"); // A4 size page of PDF

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    pdf.save("Movimientos - Fondo de reserva.pdf");
  };

  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
  });

  const activeRecurringPayment = isIterableArray(
    showReserve.reserve_fund_payments
  ) && showReserve.reserve_fund_payments.find((payment) => payment.is_active);

  const hasActiveRecurringPayment = Boolean(activeRecurringPayment);

  const handleEditAmount = (payment) => {
    setEditingPayment(payment);
  };

  const handleToggleStatus = (paymentId, isActive) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: isActive
        ? "Se desactivará este aporte recurrente."
        : "Se activará este aporte recurrente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#9341af",
      cancelButtonColor: "#bbb",
      confirmButtonText: isActive ? "Si, desactivar" : "Si, activar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (!result.value) return;
      try {
        await toggleReserveFundPaymentStatus(paymentId, isActive ? 0 : 1);
        Toast.fire({
          type: "success",
          title: isActive
            ? "Aporte desactivado correctamente."
            : "Aporte activado correctamente.",
        });
        await fetchApiShow();
      } catch (error) {
        handleErrorMessage(error);
      }
    });
  };

  useEffect(() => {
    const monto = Number(
      reserveFund?.reduce((a, c) => {
        return a + Number(c?.total_paid || 0);
      }, 0) || 0
    ).toFixed(2);
    setAmount(monto);
  }, [reserveFund]);

  /*  useEffect(() => {
    const monto = reserveFund
      .reduce((c) => {
        return c.payments;
      }, 0)
      .toFixed(2);
      setExist(monto);
    console.log(exist);
  }, [reserveFund]); */

  useEffect(() => {
    let isMounted = true;
    if (reserveFundId) {
      const getReserveFund = async () => {
        setIsLoading(true);
        try {
          const { data } = await fetchReserveFundDetails({
            reserveFundId,
            condominiumId: selectedCondominium,
          });
          if (isMounted) setReserveFund(data);
        } catch (e) {
          isMounted && setError(e);
        } finally {
          isMounted && setIsLoading(false);
        }
      };
      getReserveFund();
    }
    return () => {
      isMounted = false;
    };
  }, [reserveFundId]);


  return (
    <>
      <PageHeader
        title={`Detalles del fondo de reserva`}
        titleTag="h2"
        description=" "
        className="mb-3"
        col={{ lg: 9 }}
      >
        <Col xs={12} className=" shadow-none border-top">
          <Row className="mb-1 mt-1">
            <Col className="d-flex align-items-center">
              <div className="media-body">
                <h6 className="mb-0 font-weight-semi-bold">
                  <span className="text-900">
                    <p className="m-0">{showReserve.name}</p>
                  </span>
                </h6>
                <p className="m-0">{showReserve.description}</p>
                <p className="m-0">
                  creada el{" "}
                  {moment(showReserve.created_at).format("DD-MM-YYYY")}
                </p>
              </div>
            </Col>
            <Col className="d-flex justify-content-start flex-column align-items-end">
              <Row>
                <Col xs={12}>
                  <p className="text-right mb-0">Monto disponible</p>
                </Col>
                <Col xs={12}>
                  <h6 className="text-right text-primary mb-1">
                    <NumberFormat
                      prefix={`${baseCurrency.symbol} `}
                      allowedDecimalSeparators={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      displayType="text"
                      value={showReserve.money_available}
                    />
                    <NumberFormat
                      className="text-right"
                      displayType="text"
                      allowedDecimalSeparators={true}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale
                      prefix={" | " + curr?.currency?.iso + " "}
                      value={
                        showReserve.money_available * Number(curr?.value || 0)
                      }
                    />
                  </h6>
                </Col>
              </Row>
              {hasActiveRecurringPayment && (
                <Row>
                  <Col xs={12}>
                    <p className="text-right mb-0">
                      Monto del aporte recurrente
                    </p>
                  </Col>
                  <Col xs={12}>
                    <h6 className="text-right text-info mb-1">
                      <NumberFormat
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        displayType="text"
                        value={activeRecurringPayment.amount}
                      />
                      <NumberFormat
                        className="text-right"
                        displayType="text"
                        allowedDecimalSeparators={true}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale
                        prefix={" | " + curr?.currency?.iso + " "}
                        value={
                          activeRecurringPayment.amount * Number(curr?.value || 0)
                        }
                      />
                    </h6>
                  </Col>
                </Row>
              )}
              {showReserve.pending_to_collect > 0 && (
                <Row>
                  <Col xs={12}>
                    <p className="text-right mb-0">
                      Pendiente por cobrar (todos los ciclos)
                    </p>
                  </Col>
                  <Col xs={12}>
                    <h6 className="text-right text-warning mb-1">
                      <NumberFormat
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        displayType="text"
                        value={showReserve.pending_to_collect}
                      />
                    </h6>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Col>

        <SupportLink />
      </PageHeader>
      {isIterableArray(showReserve.reserve_fund_payments) && (
        <Card className="mb-3">
          <FalconCardHeader title="Aportes registrados" />
          <CardBody>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th style={{ fontSize: "0.9rem" }}>Nombre</th>
                  <th style={{ fontSize: "0.9rem" }}>Monto</th>
                  <th style={{ fontSize: "0.9rem" }}>Tipo</th>
                  <th style={{ fontSize: "0.9rem" }}>Estado</th>
                  <th style={{ fontSize: "0.9rem" }}></th>
                </tr>
              </thead>
              <tbody>
                {showReserve.reserve_fund_payments.map((payment) => (
                  <tr key={payment.id} style={{ fontSize: "0.8rem" }}>
                    <td>{payment.name}</td>
                    <td>
                      <NumberFormat
                        prefix={`${baseCurrency.symbol} `}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator
                        displayType="text"
                        value={payment.amount}
                      />
                    </td>
                    <td>{payment.is_active ? "Recurrente" : "Puntual"}</td>
                    <td>
                      {payment.is_active ? (
                        <Badge className="rounded-pill" color="success">
                          Activo
                        </Badge>
                      ) : (
                        <Badge className="rounded-pill" color="secondary">
                          Inactivo
                        </Badge>
                      )}
                    </td>
                    <td>
                      <ButtonIcon
                        color="falcon-default"
                        size="sm"
                        icon={payment.is_active ? faToggleOn : faToggleOff}
                        className="mr-2"
                        onClick={() =>
                          handleToggleStatus(payment.id, payment.is_active)
                        }
                      >
                        {payment.is_active ? "Desactivar" : "Activar"}
                      </ButtonIcon>
                      {payment.is_active && (
                        <ButtonIcon
                          color="falcon-default"
                          size="sm"
                          icon="edit"
                          onClick={() => handleEditAmount(payment)}
                        >
                          Editar monto
                        </ButtonIcon>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      )}

      <Card className="p-0 mb-3">
        <FalconCardHeader title="" className="p-0">
          <Row>
            <Col>
              <Row className="justify-content-center mb-3">
                <Col
                  xs="auto"
                  lg="auto"
                  md={12}
                  sm={12}
                  className="d-flex align-items-center justify-content-center"
                >
                  <Label className="mb-0 mr-2">
                    <FontAwesomeIcon icon={faFilter} />
                  </Label>
                </Col>
                <Col
                  xs="auto"
                  sm="auto"
                  lg="auto"
                  className="d-flex align-items-center flex-sm-column flex-md-column flex-lg-row"
                >
                  <Label className="mr-2 mb-0">Desde</Label>
                  <Datetime
                    value={formDate.since}
                    isValidDate={(current, selected) => {
                      return !current.isAfter();
                    }}
                    onChange={(d) =>
                      setformDate((prev) => ({
                        ...prev,
                        since: d,
                      }))
                    }
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                  />
                </Col>
                <Col
                  xs="auto"
                  sm="auto"
                  lg="auto"
                  className="d-flex align-items-center flex-sm-column flex-md-column flex-lg-row"
                >
                  <Label className="mr-2 mb-0">Hasta</Label>
                  <Datetime
                    value={formDate.to}
                    className="mr-2"
                    isValidDate={(current, selected) => {
                      return (
                        current.isAfter(formDate.since) && !current.isAfter()
                      );
                    }}
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                    onChange={(d) =>
                      setformDate((prev) => ({ ...prev, to: d }))
                    }
                  />
                </Col>
                <Col
                  xs="auto"
                  className="pl-0 d-flex align-items-md-end align-items-lg-center align-items-sm-end"
                >
                  <ButtonIcon
                    className="text-nowrap d-sm-none d-lg-block"
                    disabled={!formDate.to}
                    icon={faSearch}
                    color="falcon-default"
                    onClick={() => {
                      setParams((prev) => {
                        return {
                          ...prev,
                          start_date: formDate.since.format("YYYY-MM-DD"),
                          end_date: formDate.to.format("YYYY-MM-DD"),
                        };
                      });
                    }}
                  >
                    Buscar
                  </ButtonIcon>
                  <Button
                    className="text-nowrap d-sm-block d-lg-none"
                    disabled={!formDate.to}
                    color="falcon-default"
                    onClick={() => {
                      setParams((prev) => {
                        return {
                          ...prev,
                          start_date: formDate.since.format("YYYY-MM-DD"),
                          end_date: formDate.to.format("YYYY-MM-DD"),
                        };
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </FalconCardHeader>

        <CardBody>
          <Row className="justify-content-between align-items-center d-flex">
            <Col md>
              <h5 className="mb-2 mb-md-0">Descargar movimientos</h5>
            </Col>
            <Col
              xs="auto"
              lg={"auto"}
              md={12}
              className="justify-self-end d-flex justify-content-end align-items-center"
            >
              <ButtonIcon
                color="falcon-default"
                size="sm"
                icon="arrow-down"
                onClick={handleDownload}
                disabled={!filteredData}
                className="mr-2 mb-2 mb-sm-0"
              >
                Descargar (.pdf)
              </ButtonIcon>
              <ButtonIcon
                onClick={handlePrint}
                color="falcon-default"
                size="sm"
                icon="print"
                disabled={!filteredData}
                className="mr-2 mb-2 mb-sm-0"
              >
                Imprimir
              </ButtonIcon>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card>
        <Card
          innerRef={(e) => {
            reportRef.current = e;
          }}
          style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
        >
          <CardBody>
            <PreloadState cond={isIterableArray(data)} loading={movementsFund}>
              <Row className="align-items-center text-center mb-3">
                <Col sm={6} className="text-sm-left">
                  <div className="text-sm-left col-sm-6">
                    <Logo width={150} />
                  </div>
                </Col>
                <Col sm={6} className="text-sm-right mt-3 mt-sm-0">
                  <h4>Movimientos del fondo de reserva - {showReserve.name}</h4>
                  <h5>Condominio {condominium}</h5>
                  <p className="fs--1 mb-0">{address}</p>
                  <p className="fs--1 mb-0">RIF {phone}</p>
                  <h6 className="fs--1 mt-2 mb-0">Monto disponible</h6>
                  <NumberFormat
                    prefix={`${baseCurrency.symbol} `}
                    thousandSeparator
                    decimalScale={2}
                    fixedDecimalScale
                    displayType="text"
                    value={showReserve.money_available}
                  />
                  <NumberFormat
                    className="text-right"
                    displayType="text"
                    allowedDecimalSeparators={true}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale
                    prefix={" | " + curr?.currency?.iso + " "}
                    value={
                      showReserve.money_available * Number(curr?.value || 0)
                    }
                  />
                </Col>
                {formDate.to && (
                  <Col xs={12}>
                    <hr />
                  </Col>
                )}
              </Row>

              {data.length > 0 ? (
                <>
                  <Fragment>
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th style={{ fontSize: "0.9rem" }}>Fecha</th>
                          <th style={{ fontSize: "0.9rem" }}>Concepto / Propietario</th>
                          <th style={{ fontSize: "0.9rem" }}>Descripción</th>
                          <th style={{ fontSize: "0.9rem" }}>Tipo</th>
                          <th style={{ fontSize: "0.9rem" }}>Monto</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.map((movement) => (
                          <tr key={movement.id} style={{ fontSize: "0.8rem" }}>
                            <td>{getDate(movement.created_at)}</td>
                            <td>
                              {movement?.property !== null ? (
                                <p>
                                  {movement?.property?.user?.data?.firstname}{" "}
                                  {movement?.property?.user?.data?.lastname}
                                </p>
                              ) : movement?.provider !== null ? (
                                <p>{movement?.provider}</p>
                              ) : (
                                <p>N/A</p>
                              )}
                            </td>
                            <td>
                              {movement.description.message
                                ? movement.description.message
                                : movement.description}{" "}
                            </td>
                            <td>
                              {movement.isDecrement === 0 ? (
                                <Badge className="rounded-capsule badge-soft-success">
                                  Ingreso
                                  <FontAwesomeIcon
                                    className="ml-2 "
                                    icon="fa-solid fa-arrow-up"
                                  />
                                </Badge>
                              ) : (
                                <Badge className="rounded-capsule badge-soft-warning">
                                  Egreso
                                  <FontAwesomeIcon
                                    className="ml-2"
                                    icon="fa-solid fa-arrow-down"
                                  />
                                </Badge>
                              )}
                            </td>
                            <td>
                              {" "}
                              <Row>
                                <Col>
                                  {" "}
                                  <NumberFormat
                                    className="text-right"
                                    displayType="text"
                                    allowedDecimalSeparators={true}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix={`${baseCurrency.symbol} `}
                                    value={movement.amount}
                                  />
                                  {resolveConvertedAmount(movement) !== null && (
                                    <NumberFormat
                                      className="text-right"
                                      displayType="text"
                                      allowedDecimalSeparators={true}
                                      thousandSeparator={true}
                                      decimalScale={2}
                                      fixedDecimalScale
                                      prefix={" | " + (curr?.currency?.iso || "") + " "}
                                      value={resolveConvertedAmount(movement)}
                                    />
                                  )}
                                </Col>
                              </Row>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Fragment>
                </>
              ) : (
                <Row className="p-card">
                  <Col>
                    <Alert color="info" className="mb-0">
                      Al parecer aún no hay movimientos para mostrar.
                    </Alert>
                  </Col>
                </Row>
              )}
            </PreloadState>
          </CardBody>
        </Card>
        <FullPagination
          nextPage={nextPage}
          prevPage={previousPage}
          goToPage={goToPage}
          meta={meta}
          className={"shadow-none"}
          posText={"Movimientos"}
          perPage={perPage}
          style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
        />
      </Card>
      {/*       <>
        <ReserveFundDetailsList />
      </> */}
      <EditReserveFundAmountModal
        isOpen={Boolean(editingPayment)}
        toggle={() => setEditingPayment(null)}
        payment={editingPayment}
        condominiumId={selectedCondominium}
        onSuccess={fetchApiShow}
      />
    </>
  );
};

export default withRedirect(ReserveFundDetails);
